import * as React from 'react';
import { connect } from 'react-redux';
import { AppDataState } from 'reducers/data';
import { App, AppProps } from 'components/app';

const AppConnector = (props: AppProps) => {
    return <App {...props} />;
};

const mapStateToProps = (state: AppDataState): AppProps => {
    return {
        accounts: state.visibleAccounts,
        currentAccountId: state.currentAccountId,
        currentProduct: state.currentProduct,
        productList: state.productList,
        roles: state.roles,
        status: state.status,
        users: state.users,
        visibleUsers: state.visibleUsers,
        currentAccountDetails: state.currentAccountDetails
    };
};

export { AppConnector };
export default connect(mapStateToProps)(AppConnector);



// WEBPACK FOOTER //
// ./src/components/appConnector.tsx